import moment from 'moment';
import { CustomNotification } from '../../../../../v2-components/Notification';
import { Notification } from '../../../../../v2-components/Notification/constant';

export const checkDateOverlap = (newChange, temporalChanges) => {
  const { from, to } = newChange;

  const newFrom = moment(from, 'DD/MM/YY');
  const newTo   = moment(to,   'DD/MM/YY');

  const isSingleDate = newFrom.isSame(newTo, 'day');   

  for (let change of temporalChanges) {
    const existingFrom = moment(change.from, 'DD/MM/YY');
    const existingTo   = moment(change.to,   'DD/MM/YY');

    const existingIsSingle = existingFrom.isSame(existingTo, 'day');

    if (isSingleDate) {
      if (

        (!existingIsSingle && newFrom.isBetween(existingFrom, existingTo, null, '[]')) ||

        (existingIsSingle && existingFrom.isSame(newFrom, 'day'))
      ) {
        CustomNotification({
          type: Notification.type.error,
          message: Notification.message.error,
          description: 'La fecha ya se solapa con un cambio temporal existente.',
        });
        return false;
      }
    }

    else {
      const overlap =
        newFrom.isBetween(existingFrom, existingTo, null, '[)') ||

        newTo.isBetween(existingFrom, existingTo, null, '(]') ||

        existingFrom.isBetween(newFrom, newTo, null, '[)') ||

        existingTo.isBetween(newFrom, newTo, null, '(]') ||

        newFrom.isSame(existingFrom, 'day');

      const singleInsideNew =
        existingIsSingle && existingFrom.isBetween(newFrom, newTo, null, '[]');

      if (overlap || singleInsideNew) {
        CustomNotification({
          type: Notification.type.error,
          message: Notification.message.error,
          description: 'El rango de fechas se solapa con un cambio temporal existente.',
        });
        return false;
      }
    }
  }

  return true; 
};
